export default __webpack_public_path__ + "static/marketing-laptop-59e276dfb989374ced3de7e749f36483.svg";